import { render, staticRenderFns } from "./upload_list.vue?vue&type=template&id=35a985dd&scoped=true&"
import script from "./upload_list.vue?vue&type=script&lang=js&"
export * from "./upload_list.vue?vue&type=script&lang=js&"
import style0 from "./upload_list.vue?vue&type=style&index=0&id=35a985dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a985dd",
  null
  
)

export default component.exports